export default [
  {
    path: '/admin/trader/hedge-pair-trading',
    name: 'HedgePairTrading',
    component: () => import('@/views/Admin/Trader/HedgePairTrading/Index.vue'),
    meta: {
      pageTitle: 'Hedge Pair Trading',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Hedge Pair Trading', active: true },
      ],
      resource: 'targets.list',
      action: 'read',
    },
  },
]
